module.exports = __webpack_public_path__ + "img/balance_symmetry_175.9e1deb4c.jpg";